import $ from 'jquery';

class Modal {
	show(content) {
		const closeClosestModel = (element) => $(element).closest('.element--modal').remove();

		const body = $('body');
		const modal = $('<div class="element--modal"></div>');
		const backdrop = $('<div class="element--modal-backdrop"></div>').appendTo(modal);
		const modalPanel = $('<div class="element--modal-panel"></div>').appendTo(modal);

		backdrop.click(() => closeClosestModel(backdrop));
		$(document).on('click', '.element--modal .element--modal-close-button', e => {
			closeClosestModel(e.target);
		});

		modalPanel.append(content);
		body.append(modal);
	}
}

export default function showModal(content) {
	const modal = new Modal();
	modal.show(content);
	return modal;
}
